import React, {useContext} from "react";
import { useLocation} from "react-router-dom";

import Sidebar from "../sidebar/Sidebar";
import AppNavbar from "../navbar/AppNavbar";
import Footer from "../footer/Footer";
import { Outlet } from "react-router-dom";

function Layout(props) {
  const location = useLocation();
  const mainPanel = React.useRef(null);
 
  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainPanel.current.scrollTop = 0;
    if (
      window.innerWidth < 993 &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
      var element = document.getElementById("bodyClick");
      element.parentNode.removeChild(element);
    }
  }, [location]);
  return (
    <>
      <div className="wrapper">
        <Sidebar/>
        <div className="main-panel" ref={mainPanel}>
          <AppNavbar/>
          <div className="content">
            {/*props.children*/}
            <Outlet/>
          </div>
          <Footer />
        </div>
      </div>
      
    </>
  );
}

export default Layout;
